import { asSingleStyleConfig } from '../../../../utils/theme';
import { dangerButtonStyles, primaryButtonStyles, secondaryButtonStyles, tertiaryButtonStyles } from './button';
export var IconButton = asSingleStyleConfig({
  variants: {
    primary: props => primaryButtonStyles(props).button,
    secondary: props => secondaryButtonStyles(props).button,
    tertiary: props => tertiaryButtonStyles(props).button,
    danger: props => dangerButtonStyles(props).button,
    menu: props => tertiaryButtonStyles(props).button
  }
});